<template>
  <div class="mt-4 helping-carousel">
    <three-dots class="dots"/>
    <div class="title mb-4">Помогаю решить</div>
    <b-carousel
      id="carousel-1"
      class="mb-100"
      v-model="slide"
      :interval="4000"
      controls
      indicators
      background="#ababab"
      img-width="1024"
      img-height="480"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <b-carousel-slide
        caption="Сексуальная неудовлетворенность"
        text="Развитие чувственности и сексуальности"
        :img-src="require('@/assets/help1.png')"
      ></b-carousel-slide>
      <b-carousel-slide
        caption="Стыд и вина"
        text="Повышение самооценки и принятие себя"
        :img-src="require('@/assets/help2.png')"
      ></b-carousel-slide>
      <b-carousel-slide
        caption="Психологические травмы"
        text="Нахождение ресурсов в прожитых переживаниях"
        :img-src="require('@/assets/help3.png')"
      ></b-carousel-slide>
      <b-carousel-slide
        caption="Усталость"
        text="Забота о внутреннем ребёнке "
        :img-src="require('@/assets/help4.png')"
      ></b-carousel-slide>
      <b-carousel-slide
        caption="Конфликты на работе"
        text="Выстраивание здоровых психологических границ"
        :img-src="require('@/assets/help5.png')"
      ></b-carousel-slide>
      <b-carousel-slide
        caption="Сложные отношения с мамой"
        text="Здоровая сепарация от матери "
        :img-src="require('@/assets/help6.png')"
      ></b-carousel-slide>
      <b-carousel-slide
        caption="Кризис в отношениях"
        text="Здоровое разрешение конфликтов"
        :img-src="require('@/assets/help7.png')"
      ></b-carousel-slide>
      <b-carousel-slide
        caption="Не могу достичь успеха"
        text="Постановка и достижение цели"
        :img-src="require('@/assets/help8.png')"
      ></b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
  import ThreeDots from '@/components/icons/ThreeDots';
  export default {
    name: "HelpingCarousel",
    components: {ThreeDots},
    data() {
      return {
        slide: 0,
        sliding: null
      }
    },
    methods: {
      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      }
    }
  }
</script>

<style lang="scss">
  @media screen and (max-width: 930px){
    .helping-carousel {
      display: block !important;
    }
  }
  .helping-carousel {
    display: none;
  }
  .mb-100 {
    margin-bottom: 95px;
  }
  #carousel-1 {
    max-width: 700px !important;
    margin-left: auto;
    margin-right: auto;
    .carousel-control-prev-icon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='15' fill='none' viewBox='0 0 11 17'%3E%3Cpath fill='%23fff' d='M9.945 8.37l-7.12-7.12c-.165-.165-.385-.256-.62-.256-.234 0-.454.09-.618.256l-.525.524c-.34.341-.34.897 0 1.238l5.98 5.979-5.986 5.985c-.165.165-.256.385-.256.619 0 .234.091.454.256.62l.524.523c.165.165.385.256.62.256.233 0 .453-.09.618-.256l7.127-7.126c.165-.166.255-.386.255-.621 0-.236-.09-.456-.255-.621z'/%3E%3C/svg%3E%0A");
      transform: rotate(-180deg);
    }
    .carousel-control-next-icon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='15' fill='none' viewBox='0 0 11 17'%3E%3Cpath fill='%23fff' d='M9.945 8.37l-7.12-7.12c-.165-.165-.385-.256-.62-.256-.234 0-.454.09-.618.256l-.525.524c-.34.341-.34.897 0 1.238l5.98 5.979-5.986 5.985c-.165.165-.256.385-.256.619 0 .234.091.454.256.62l.524.523c.165.165.385.256.62.256.233 0 .453-.09.618-.256l7.127-7.126c.165-.166.255-.386.255-.621 0-.236-.09-.456-.255-.621z'/%3E%3C/svg%3E%0A");
    }
    .carousel-caption {
      padding-bottom: 0;
      p {
        margin-bottom: 0;
      }
    }
    .carousel-indicators {
      bottom: -60px;
    }
    .carousel-indicators li {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      opacity: 1;
      border: solid 1px #7e7e7e;
    }
    .carousel-indicators .active {
      background: #5ec8f5;
      width: 10px;
      height: 10px;
      border: none;
    }
  }
</style>